import React, { useState } from 'react';
import PropTypes from 'prop-types';

import UploadArea from '@components/common/filestack_uploader/upload_area';
import VersionUppy from '@components/common/uppy/version_uppy';
import download from '@helpers/download';
import { postReservations } from '@api/v4/attachments/reservations_NEW';
import { updateReservations } from '@components/asset/modal/tabs/workflow/helper';

const SubmitButton = ({
  activeAttachment,
  asset,
  checkedInStatus,
  handleClose,
  initializeTab,
  setAttachmentReservations,
  versionCard,
  textareaValue,
  updateFetchControllers,
}) => {
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);

  const handleToggleCheckinCheckout = () => {
    setIsSubmitDisabled(true);
    const options = {
      attachmentKey: activeAttachment.id,
      checkinCheckoutNote: textareaValue,
      updatedStatus: checkedInStatus === 'checked_in' ? 'checked_out' : 'checked_in',
      params: { include: 'user' }
    };

    postReservations(options, updateFetchControllers)
      .then((response) => {
        if (response && !response.ok) {
          setAttachmentReservations((prevState) => (
            updateReservations(response, prevState, activeAttachment.id)
          ));
        }

        if (checkedInStatus === 'checked_in') { // only need for checking out
          handleClose();
        }
      })
      .catch((err) => {
        handleClose();
        console.log(err);
      });
  };

  const handleSubmitCheckout = () => {
    const { url, filename, metadata } = versionCard.version_details;
    download(url, { filename, filetype: metadata.mime_type });
    handleToggleCheckinCheckout();
  };

  const uploadOptions = {
    maxFiles: 1,
    onFileUploadStarted: () => setIsSubmitDisabled(true),
  };

  if (checkedInStatus === 'checked_in') {
    return (
      <button
        className="submit-checkin-checkout-button button primary lg"
        disabled={isSubmitDisabled}
        onClick={handleSubmitCheckout}
        type="button"
      >
        {t('Check Out & Download')}
      </button>
    );
  }

  if (checkedInStatus === 'checked_out' && !BFG.hasFeature('uppy_uploader_features') && !isSubmitDisabled) {
    return (
      <UploadArea
        asset={asset}
        assetKey={asset.id}
        attachment={activeAttachment}
        handleToggleCheckinCheckout={handleToggleCheckinCheckout}
        options={uploadOptions}
        type="button"
        uniqDomElement={`version-status-uploader-checkin-${activeAttachment.id}`}
        updateTab={initializeTab}
        updateVersionUploading={() => {}}
        uploadType="attachment-version-status"
      />
    );
  }

  if (checkedInStatus === 'checked_out' && BFG.hasFeature('uppy_uploader_features') && !isSubmitDisabled) {
    return (
      <VersionUppy
        attachmentKey={activeAttachment.id}
        assetKey={asset.id}
        handleToggleCheckinCheckout={handleToggleCheckinCheckout}
        updateTab={initializeTab}
        updateVersionUploading={() => {}}
      />
    );
  }

  return null;
};

SubmitButton.propTypes = {
  activeAttachment: PropTypes.shape({
    id: PropTypes.string
  }).isRequired,
  asset: PropTypes.shape({
    asset_key: PropTypes.string,
    id: PropTypes.string,
  }).isRequired,
  checkedInStatus: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  initializeTab: PropTypes.func.isRequired,
  setAttachmentReservations: PropTypes.func.isRequired,
  textareaValue: PropTypes.string.isRequired,
  updateFetchControllers: PropTypes.func.isRequired,
  versionCard: PropTypes.shape({
    version_details: PropTypes.shape({
      url: PropTypes.string,
      filename: PropTypes.string,
      metadata: PropTypes.shape({
        mime_type: PropTypes.string,
      }),
    })
  }).isRequired,
};

export default SubmitButton;
